import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgForOf} from '@angular/common';
import {LangChangeEvent, TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-our-services',
  imports: [
    NgForOf,
    TranslatePipe
  ],
  templateUrl: './our-services.component.html',
  styleUrl: './our-services.component.scss'
})
export class OurServicesComponent implements OnInit, OnDestroy{
  public benefits: string[] = []
  private langChangeSub!: Subscription;

  constructor(public translate: TranslateService) {
  }

  private assignBenefits() {
    this.benefits = [
      this.translate.instant("services.benefit1"),
      this.translate.instant("services.benefit2"),
      this.translate.instant("services.benefit3"),
      this.translate.instant("services.benefit4"),
    ]
  }

  ngOnInit(): void {
    this.assignBenefits();
    this.langChangeSub = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.assignBenefits();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }
}
